import { Operator } from './operator.interface';
import { OperatorService } from './operator.service';

const service = new OperatorService();

export interface OperatorState {
   operators: Array<Operator>;
   operatorKeys: Array<{ key: string; value: string }>;
}

const state: OperatorState = {
   operators: [],
   operatorKeys: [
      { key: 'greater-than', value: '>' },
      { key: 'greater-or-equal-than', value: '>=' },
      { key: 'lower-than', value: '<' },
      { key: 'equal-than', value: '=' },
      { key: 'not-equal-than', value: '≠' },
   ],
};

const getters = {
   operators: (state: OperatorState) => state.operators,
   operatorKeys: (state: OperatorState) => state.operatorKeys,
};

const mutations = {
   setOperators(state: OperatorState, operators: Array<Operator>) {
      state.operators = operators;
   },
};

const actions = {
   async getOperators(context: any) {
      return await service.getOperators().then((operators) => {
         context.commit('setOperators', operators);
         return operators;
      });
   },
};

export default {
   namespaced: true,
   state,
   getters,
   mutations,
   actions,
};
